import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { eliminarOrden } from '../../../../actions/ordenesSalida';

const EliminarOrdenModal = ({ show, onHide, idOrden, idProyecto, onSuccess }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idOrden) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(eliminarOrden(idOrden, idProyecto));
        setSaving(false);

        if (!ok) return;

        onHide();
        if (typeof onSuccess === 'function') onSuccess();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Eliminar orden de salida</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas eliminar esta orden de salida? Esta acción no es reversible.
                    {' '}Si la orden proviene de una cotización, esta quedará disponible nuevamente para generar otra orden.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Eliminar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarOrdenModal;
